import {
    all,
    call,
    put,
    takeLatest,
} from 'redux-saga/effects';
import {
    OverlayAction,
    OverlayContent,
} from './enum';
import {
    initOverlay,
    setOverlayLoaded,
    setOverlayVisibility,
} from './action';
import { AdditionalPageOptions } from '../../interface';
import { getCMSConfig } from '../../util/cms';
import {
    RequestParams,
    requestHtml,
} from '@vfde-sails/utils';
import { debugInfo } from '../../util/debug';
import {
    startLoading,
    stopLoading,
} from '../App/action';
import { createLoadingSpinnerElement } from '../../components/loadingSpinner';
import { trackAvcFormSaga } from '../AvailabilityCheck/util/generator';
import {
    trackLMForm,
    trackOverlayOpening,
} from '../../tracking/tracking';
import {
    LMFormTrackingState,
    TrackingFormStepName,
} from '../../tracking/enum';
import { TRACKING_LEGAL_OVERLAY_OPENING } from '../../tracking/constants';

/**
 * Fetches html of the footnote content and injects it into the overlay
 */
export function* initOverlaySaga ({ overlay }: ReturnType<typeof initOverlay>) {
    try {
        yield put(startLoading(OverlayAction.INIT));
        const { htmlLinks }: AdditionalPageOptions = yield call(getCMSConfig);
        const requestOptions: RequestParams = {};



        const content: string[] = yield all([
            call(requestHtml, htmlLinks.avcForm, requestOptions),
            call(requestHtml, htmlLinks.avcResult, requestOptions),
            call(requestHtml, htmlLinks.lmForm, requestOptions),
            call(requestHtml, htmlLinks.legalOverlay, requestOptions),
        ]);

        const loadingSpinner = createLoadingSpinnerElement() as HTMLElement;

        overlay.injectContent(...content);
        overlay.getOverlayContentContainer().appendChild(loadingSpinner);

        yield put(setOverlayLoaded());
    }
    catch (error) {
        yield call(debugInfo, error);
    }
    finally {
        yield put(stopLoading(OverlayAction.INIT));
    }
}

/**
 * Tracks the overlay opening
 */
export function* setOverlayVisibilitySaga (action: ReturnType<typeof setOverlayVisibility>) {
    if (!action.isVisible) {
        return;
    }

    if (action.activeContent === OverlayContent.AVC) {
        yield call(trackAvcFormSaga, TrackingFormStepName.SHOW);
    }

    if (action.activeContent === OverlayContent.LM_FORM) {
        yield call(trackLMForm, LMFormTrackingState.OPEN);
    }

    if (action.activeContent === OverlayContent.LEGAL) {
        yield call(trackOverlayOpening, TRACKING_LEGAL_OVERLAY_OPENING);
    }
}

/**
 * Overlay saga
 */
export default function* overlaySaga () {
    yield takeLatest(OverlayAction.INIT, initOverlaySaga);
    yield takeLatest(OverlayAction.SET_OVERLAY_VISIBILITY, setOverlayVisibilitySaga);
}
